import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

/**
 * Attaches the Azure AD access token to outgoing requests as 'X-MSAL-Token', matching the
 * PolygraphAPI/BaseController pattern (the API validates that header).
 *
 * CURRENTLY OFF: guarded to pass through untouched until `environment.apiScope` is set, so it
 * can't break the app before the API app-registration/scope exists. To turn on: set apiScope
 * (and enforce on the API by uncommenting the 403 in MsalAuthorizationFilter).
 */
@Injectable()
export class SecurityInterceptor implements HttpInterceptor {
  constructor(private authService: MsalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accounts = this.authService.instance.getAllAccounts();

    // OFF-SWITCH: no apiScope configured yet, or not signed in -> send request unchanged.
    if (!environment.apiScope || accounts.length === 0) {
      return next.handle(req);
    }

    return from(
      this.authService.instance.acquireTokenSilent({
        scopes: [environment.apiScope],
        account: accounts[0],
      })
    ).pipe(
      switchMap((result) => {
        const secureReq = req.clone({
          setHeaders: { 'X-MSAL-Token': result.accessToken },
        });
        return next.handle(secureReq);
      })
    );
  }
}
